module.exports = __webpack_public_path__ + "static/img/ls7.d9a07ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-edge/ls7.png
// module id = q72W
// module chunks = 12